import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import {
    Grid,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH } from "../../../helpers/constants";
import { DiscountProposalForm } from "./DiscountProposalForm";
import { StatusProposalForm } from "./StatusProposalForm";

function DiscountStatusProposalTabs(props) {

const [tab, setTab] = useState(props.initialTab || "discount");

  return (
    <TabContext value={tab}>
        <Tabs
            variant="fullWidth"
            value={tab}
            onChange={(e, newValue) => setTab(newValue)}
        >
            <Tab value={"discount"} label={t("products.changeDiscount")} />
            <Tab value={"status"} label={t("products.changeStatus")} sx={{opacity: props.disabledStatusProposal ? 0 : null}} disabled={props.disabledStatusProposal}/>
        </Tabs>
        <TabPanel value={"discount"} sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    // bgcolor: "whitesmoke",
                    // borderRadius: 2,
                    p: 2,
                }}
            >
                <DiscountProposalForm productIds={props.productIds} onClose={props.onClose}/>
            </Grid>
        </TabPanel>
        <TabPanel value={"status"} sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    // bgcolor: "whitesmoke",
                    // borderRadius: 2,
                    p: 2,
                }}
            >
                <StatusProposalForm productIds={props.productIds} onClose={props.onClose}/>
            </Grid>
        </TabPanel>
    </TabContext>
  )
}

export default DiscountStatusProposalTabs